export enum SearchContext {
  Collection = 0,
  Project = 1
}

export enum SearchMode {
  Basic,
  Advanced
}

export interface ISearch {
  id: string;
  name: string;
  expression: any;
  dirty: boolean;
  context: SearchContext;
}

// Expose enums on window.app.model.search so plain-JS files (e.g. navigation.js)
// can reference app.model.search.SearchContext / SearchMode at runtime.
(window as any).app = (window as any).app || {};
(window as any).app.model = (window as any).app.model || {};
(window as any).app.model.search = (window as any).app.model.search || {};
(window as any).app.model.search.SearchContext = SearchContext;
(window as any).app.model.search.SearchMode = SearchMode;
